import {IOhmOperation, OhmEngine} from '@mintdata-wsp/common/controllers/spreadsheet/formula/engine/OhmEngine';
import * as ohm from 'ohm-js';
import {ActionDict, Grammar, Semantics} from 'ohm-js';

export class OhmUtils
{
    public static createEngine(grammarContent:string, operations:Array<IOhmOperation>):OhmEngine
    {
        const grammar:Grammar = ohm['grammar'](grammarContent);
        const semantics:Semantics = grammar.createSemantics();

        for( const operation of operations )
        {
            const actionsDict:ActionDict = OhmUtils.createActionDict(operation);

            semantics.addOperation(operation.operationName, actionsDict);
        }

        return new OhmEngine(grammar, semantics);
    }

    public static createActionDict(actionsInst:IOhmOperation):ActionDict
    {
        const actionDict:ActionDict = {};

        const objWithActions = actionsInst['__proto__'];

        for( const prop in objWithActions )
        {
            if( objWithActions.hasOwnProperty(prop) )
            {
                const actionFn = objWithActions[prop];

                if( typeof actionFn === 'function' && !prop.startsWith('__') && !(prop === 'constructor') )
                    actionDict[prop] = actionFn.bind(actionsInst);
            }
        }

        return actionDict;
    }

    public static isCircularRefException(error):boolean
    {
        return error &&
            error.message &&
            error.message.toLowerCase().indexOf('cycle detected in computation') !== -1;
    }
}
